import FormProps from 'components/FormProps';
import UserResource from 'models/users/resource';
import { Form, InputGroup } from 'react-bootstrap';
import React from 'react';

export type Props = FormProps<UserResource>;

export const Delete = ({ value, disabled, error }: Props) => (
  <Form.Group className="form-group">
    <InputGroup>
      <InputGroup.Text>Email</InputGroup.Text>
      <Form.Control name="email" disabled={disabled} value={value.email} isInvalid={error?.email !== undefined} />
    </InputGroup>
  </Form.Group>
);
export default Delete;
